import { Field } from 'redux-form';
import EmailInput from './EmailInput';

const EmailField = (props) => {
  return (
    <div>
      <Field
        id={props.id}
        name={props.name}
        typeName={props.typeName}
        order={props.order}
        options={props.options}
        required={props.required}
        component={EmailInput}
      />
    </div>);
}

export default EmailField;